export default __webpack_public_path__ + "c22af5ea5564b6b0f662afda293fe18b.svg";